import React from "react";
import ReactDOM from "react-dom";
export async function initAxe(): Promise<void> {
  if (process.env.CHECK_ACCESSIBILITY === "true") {
    const axe = await import("@axe-core/react");
    axe.default(React, ReactDOM, 1000).catch((error: Error) => {
      console.error(error);
    });
    // eslint-disable-next-line no-console
    console.log("Accessibility checks are enabled.");
  }
}
